import styled from "styled-components";
import PlayerPreview from "src/components/PlayerPreview";

export const CustomChannelPreview = styled(PlayerPreview)`
  &.custom-channel-preview {
    display: flex;
    align-items: center;
  }
`;
